module.exports = __webpack_public_path__ + "static/media/viagem.a3849def.jpg";